<svelte:head>
	<link rel="preconnect" href="https://fonts.gstatic.com">
	<link href="https://fonts.googleapis.com/css2?family=Lato:wght@300&family=ZCOOL+XiaoWei&display=swap" rel="stylesheet">
</svelte:head>
<script>
	//Test data
	// import diet from './data/diet.json'
	import * as d3 from 'd3';
	import Scroller from '@sveltejs/svelte-scroller';
	import LoremIpsum from './LoremIpsum.svelte';
import { text } from 'svelte/internal';


	// data preprocessing helper functions
	let dateCreator = function(dateStr){
		var dateOriginal = new Date(dateStr);
		var date = new Date(2021, dateOriginal.getMonth(), dateOriginal.getDate())
		return date;
	}; 

	let timeMaker = function(dateObj, timeStr){
		let d = dateObj;
		let timeOfDay = timeStr.split(':'); 
		d.setHours(timeOfDay[0]); // Set the hours, using implicit type coercion
		d.setMinutes(timeOfDay[1]); // You can pass Number or String. It doesn't really matter
		return d;
	};

	let timeCovert = function(timeStr){
		var timeHr =  parseInt(timeStr.split(":")[0]);
		var timeMin = parseInt(timeStr.split(":")[1]);
		return timeHr * 60 +  timeMin;
	};

	let dateNo = function(dateStr){
		var date1 = new Date("1/20/2021")
		var date2 = dateCreator(dateStr)
		const diffTime = Math.abs(date2 - date1);
		const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
		return diffDays.toString();
	}; 



	// dimension variables 
	let height = 200
	let width = height*2.65
	let viewBoxW=100
	let margin = ({top: 0, right: 20, bottom: 0, left: 20})
	let desiredData;
	let satisScale;
	let satisCircleScale;
	let satisXScale;
	let dateScale2;
	let dateScale;
	let activeCircles;
	let index=0, offset, progress;
	let string = `HIHI`;

const dietRaw = d3.csv('https://docs.google.com/spreadsheets/d/e/2PACX-1vTD5BWaZDoIKssxCarm9rjc27W7hiC-VlgW4iOnBuf64O64TleKzhqq1tbwwL0Ef3ubOO1UE6BaQfFd/pub?gid=0&single=true&output=csv')
	.then(data => {

	// console.log(data)

	desiredData = data.map(d => ({ 
		dateRaw:d.date,
		date: dateCreator(d.date),
		time: timeCovert(d.time),
		timeRaw: d.time,
		fullTime: timeMaker(dateCreator(d.date), d.time),
		epochTime: Date.parse(timeMaker(dateCreator(d.date), d.time)),
		satisfactionLevel: +d.satisfactionLevel,
		type: d.type, 
		name:d.foodName,
		new:+d.new,
		country:d.country,
		dateNo: dateNo(d.date), 
		id:"id-" + d.id,
		itemId: +d.id,
		dateDif:d.dateDif
	}));

	// console.log(desiredData)

	// scales
	satisScale = d3.scaleLinear()
                   .domain([0,d3.max(desiredData, d => d.satisfactionLevel)])
                   .range([margin.right, width/4 - margin.left]);

	satisXScale = d3.scaleLinear()
                   .domain([0,d3.max(desiredData, d => d.satisfactionLevel)])
                   .range([margin.right, width/4 - margin.left]);

	satisCircleScale = d3.scaleSqrt()
                   .domain([1,d3.max(desiredData, d => d.satisfactionLevel)])
				   .range([margin.right, width/8 - margin.left]);
	

});

$: console.log(index);
$: console.log(desiredData);


</script>

<main>

	<LoremIpsum/> 
	
	{#if desiredData && desiredData[index].id !== 'undefined'}
		<Scroller top={0.2} threshold={0.4} bottom={0.9} bind:index bind:offset bind:progress>
			<div slot="background" class='background'>
				<p><span class='date'>Day {desiredData[index].dateDif} at {desiredData[index].timeRaw}</span> 
					I 
					{#if desiredData[index].type === "drink"}
						<span>drank</span>
					{:else}
						<span>ate</span>
					{/if}			
					{desiredData[index].name}
					{#if desiredData[index].country && desiredData[index].type !== "fruit & veg" && desiredData[index].type !== "drink"}
						<span class='comma'>, a dish of {desiredData[index].country}.</span>
					{:else}
						<span class='comma'>.</span>
					{/if}
					{#if desiredData[index].new === 1}
					
						<span>It's my first time trying it.</span>
					{/if}	
				
					{#if desiredData[index].satisfactionLevel === 5}
						<span>It made my day. </span>
						<p>ヽ(＾Д＾)ﾉ ♥</p>
					{:else if desiredData[index].satisfactionLevel > 3.9}
						<span>I'm loving it.</span>
						<p>ლ(╹◡╹ლ)</p>
					{:else if desiredData[index].satisfactionLevel > 3}
						<span>It was just alright.</span>
						<p>(´〜｀*)</p>
					{:else}
						<span>It was a nightmare.</span>
						<p>(✖╭╮✖)</p>
					{/if}
				</p> 
			</div>

			<div slot="foreground" class="foreground"> 			
					{#each desiredData as d, i}
						<section style="height: {height}px; width:{width}px"> 
							<svg viewBox="0 0 {height} {width}">
								{#if (d.type === "main" || d.type === "side" || d.type === "fruit & veg")}
									{#if index === i}
										<circle
										id={d.id} 
										cx={satisScale(d.satisfactionLevel)*Math.sqrt(2)}
										cy={height/2}
										r={satisCircleScale(d.satisfactionLevel)}
										fill-opacity=1
										stroke-width=10
										stroke="white"
										fill="hotpink"
										stroke-opacity=.2
										/>
									{:else}
										<circle
										id={d.id} 
										cx={satisScale(d.satisfactionLevel)*Math.sqrt(2)}
										cy={height/2}
										r={satisCircleScale(d.satisfactionLevel)}
										fill-opacity=.1
										stroke-width=10
										stroke="white"
										fill="hotpink"
										stroke-opacity=.2
										/>
									{/if}
								{/if}
								{#if (d.type === "dessert")}
									{#if index === i}
										<rect 
											id={d.id} 
											x={satisScale(d.satisfactionLevel)}
											y={height/4}
											width={0.5* satisScale(d.satisfactionLevel* Math.sqrt(2))}
											height={0.5* satisScale(d.satisfactionLevel* Math.sqrt(2))}
											fill-opacity=1
											stroke-width=10
											stroke="white"
											stroke-opacity=.2
											fill="gold"
											transform={`translate(${satisScale(d.satisfactionLevel)*0.9},${-(height/4)}) rotate(45)`}
											/>
									{:else}
										<rect 
											id={d.id} 
											x={satisScale(d.satisfactionLevel)}
											y={height/4}
											width={0.5* satisScale(d.satisfactionLevel* Math.sqrt(2))}
											height={0.5* satisScale(d.satisfactionLevel* Math.sqrt(2))}		
											fill-opacity=.1
											stroke-width=10
											stroke="white"
											stroke-opacity=.2
											fill="gold"
											transform={`translate(${satisScale(d.satisfactionLevel)*0.9},${-(height/4)}) rotate(45)`}
											/>
									{/if}
								{/if}
								{#if (d.type === "drink")}
								{#if index === i}
									<rect 
										id={d.id} 
										x={satisScale(d.satisfactionLevel)}
										y={height/4}
										width={satisScale(d.satisfactionLevel)}
										height={satisScale(d.satisfactionLevel)}
										fill-opacity=1
										stroke-width=10
										stroke="white"
										stroke-opacity=.2
										fill="lightblue"
										/>
								{:else}
									<rect 
										id={d.id} 
										x={satisScale(d.satisfactionLevel)}
										y={height/4}
										width={satisScale(d.satisfactionLevel)}
										height={satisScale(d.satisfactionLevel)}	
										fill-opacity=.1
										stroke-width=10
										stroke="white"
										stroke-opacity=.2
										fill="lightblue"
										/>
								{/if}
							{/if}
							</svg>
						</section>
					{/each}
			</div>
		</Scroller>
	{/if}

</main>

<style>

section { 
	margin: 0 auto;
	/* left: 20%; */
}

svg{
	overflow: visible; 
	/* border-style: dotted; */
}
p{
	font-family:'ZCOOL XiaoWei', serif
}

/* .foreground{
	background-color:rgba(255,0,0,0.3)
} */

.background{
    max-width: 350px;
    padding-left: 69%;
    padding-top: 20vh;
}

.date{
	display: block;
	font-family: 'Lato', sans-serif;
}

.comma{
	margin-left: -5px;
}
</style>